import find from 'lodash/find';
import { SECTIONS_OBJ } from 'common/constants';

export const redirectUrlBuilder = (user, location) => {
	const whitelist = [...user.accessWhiteList.split(','), 'newreports', 'error'];
	// Remove starting '/' from pathaname and the splitting it to get the module name
	// like: /layout/tables => layout
	const currentModuleName = location.pathname.substring(1).split('/')[0];

	const currentModule =
		find(SECTIONS_OBJ, ({ url }) => {
			const urlStart = url.split('/')[0];
			return urlStart === currentModuleName;
		}) || {};

	if (!whitelist.includes(currentModule.name)) {
		let firstModule = { url: whitelist[0] };
		SECTIONS_OBJ.every(section => {
			const isInWhiteList = whitelist.includes(section.name);
			firstModule = isInWhiteList ? section : firstModule;

			return !isInWhiteList;
		});
		return { redirecting: true, link: `/${firstModule.url}` };
	}

	return { redirecting: false, link: '' };
};
